import { r as registerInstance, c as createEvent, h, H as Host } from './index-6f037ff9.js';
import { E as ElementSizeListener } from './elementSize-161797b7.js';

const boxLinkCss = "@charset \"UTF-8\";:host{--_box-link-bg-color:var(--box-link-bg-color, white);--_box-link-border-color:var(--box-link-border-color, black)}:host{display:block;}:host ::slotted([slot=text]){color:#333333;font-size:1.125rem;line-height:2rem;margin-left:1rem}:host .box-link{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;width:100%;max-width:30.5rem;padding:1.5rem 1.5rem 1.5rem 1rem;border-radius:0.25rem;-webkit-box-shadow:0rem 0.0625rem 0.375rem 0rem rgba(179, 176, 176, 0.5);box-shadow:0rem 0.0625rem 0.375rem 0rem rgba(179, 176, 176, 0.5);text-decoration:none;background:white}:host .box-link__icon{width:2.5rem}:host .box-link__arrow{width:2rem;margin-left:auto}:host .box-link:focus,:host .box-link:focus-visible,:host .box-link:hover{outline:0.03125rem solid var(--_box-link-border-color)}:host .box-link:hover{cursor:pointer}@media only all and (max-width: 50rem){:host ::slotted([slot=text]){font-size:1.125rem;line-height:2rem}:host .box-link{max-width:30.5rem;padding:1.75rem 1.5rem 1.75rem 1rem}}@media only all and (max-width: 31.25rem){:host ::slotted([slot=text]){font-size:1rem;line-height:1.5rem;margin-left:1rem}:host .box-link{max-width:19.5rem;padding:1.25rem 1rem}}";

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const BoxLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.eventChange = createEvent(this, "eventChange", 7);
    /**
     * Property that reflects it´s changes over an attribute of the Host tag
     * https://stenciljs.com/docs/properties#prop-options
     */
    this.first = 'Jhon';
  }
  parseLiterals(newLiterals) {
    if (newLiterals) {
      try {
        this._literals = JSON.parse(newLiterals);
      }
      catch (e) { }
    }
  }
  //** Custom event listener */
  actionHandler(event) {
    console.log(event);
  }
  /** Called just after the component is first connected to the DOM. It´s only called once */
  componentWillLoad() {
    this.parseLiterals(this.literals);
  }
  /** Component lifecycle method executed after component has fully loaded and the first render is done. Needed for the element size listener decorator */
  componentDidLoad() { }
  render() {
    var icon = '';
    if (this.extraIcon !== undefined && this.draft === undefined) {
      icon = h("img", { class: "box-link__icon", src: this.extraIcon, alt: "" });
    }
    else if (this.draft) {
      icon = h("img", { class: "box-link__icon", src: "./assets/icons/box-link/atoms-icons-24-ico-borrador.png", alt: "" });
    }
    else {
      icon = h("img", { class: "box-link__icon", src: "./assets/icons/box-link/atoms-icons-24-ico-check-circle.png", alt: "" });
    }
    return (h(Host, null, h("a", { id: this.eid + '-link', class: "box-link", tabindex: "0", "aria-label": this.ariaLabel }, icon, h("slot", { name: "text" }), h("img", { class: "box-link__arrow", src: "./assets/icons/box-link/atoms-icons-24-ico-chevron-right.png", alt: "" }))));
  }
  static get watchers() { return {
    "literals": ["parseLiterals"]
  }; }
};
__decorate([
  ElementSizeListener({ sm: 800 })
], BoxLink.prototype, "size", void 0);
BoxLink.style = boxLinkCss;

export { BoxLink as imv_ui_box_link };
